"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _styles = require("@material-ui/core/styles");

var _core = require("@emotion/core");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 1rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var header = (0, _core.css)(_templateObject());
var useProjectStyles = (0, _styles.makeStyles)({
  card: {
    "&:hover": {
      boxShadow: "0px 2px 6px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 4px 2px -1px rgba(0,0,0,0.12)"
    }
  }
});

var NotebookPreview = function NotebookPreview(_ref) {
  var message = _ref.message,
      link = _ref.link;
  var classes = useProjectStyles();
  return (0, _core.jsx)("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, (0, _core.jsx)(_Card["default"], {
    className: classes.card
  }, (0, _core.jsx)("h3", {
    css: header
  }, (0, _core.jsx)(_Icon["default"], {
    className: "fa fa-book"
  }), " ".concat(message))));
};

NotebookPreview.propTypes = {
  message: _propTypes["default"].string,
  link: _propTypes["default"].string
};
NotebookPreview.defaultProps = {
  message: "See the data science notebook",
  link: "https://github.com/hackoregon/"
};
NotebookPreview.displayName = "NotebookPreview";
var _default = NotebookPreview;
exports["default"] = _default;